import { trackPhoneClick, trackLineClick, trackEmailClick } from '@/hooks/useAnalytics';

export default function Footer() {
  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <footer className="bg-stone-950 text-white">
      {/* Top CTA Band */}
      <div className="bg-amber-500 py-6 px-6 md:px-12">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
          <div>
            <div className="font-black text-white text-xl">まずはお気軽にご相談ください</div>
            <div className="text-amber-100 text-sm mt-0.5">出張費・査定費完全無料 ／ 即日現金対応</div>
          </div>
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="tel:0120-676-337"
              onClick={() => trackPhoneClick('footer_cta')}
              className="flex items-center gap-3 px-8 py-3 rounded-full bg-white text-amber-600 font-black text-lg hover:bg-amber-50 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-fill" />
              0120-676-337
            </a>
            <a
              href="https://lin.ee/OGQq9z6"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackLineClick('footer_cta')}
              className="flex items-center gap-3 px-8 py-3 rounded-full font-black text-base hover:opacity-90 transition-opacity cursor-pointer whitespace-nowrap"
              style={{ backgroundColor: '#06C755', color: '#fff' }}
            >
              <i className="ri-line-line text-xl" />
              LINEで相談する
            </a>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-5">
              <img
                src="https://static.readdy.ai/image/832753d55565bf6aa0b01904105ef45d/602572ef5c34434494d72ca386f68265.jpeg"
                alt="天神屋 買取専門店 ロゴ — 福岡・九州の出張買取"
                title="天神屋｜買取専門店 福岡・九州全域対応"
                className="w-12 h-12 rounded-full object-cover object-top"
              />
              <div>
                <div className="font-black text-2xl tracking-wider" style={{ fontFamily: '\'Noto Serif JP\', serif' }}>天神屋</div>
                <div className="text-stone-400 text-xs">買取専門店</div>
              </div>
            </div>
            <p className="text-stone-400 text-sm leading-relaxed mb-6">
              福岡・九州全域対応の出張買取専門店。貴金属・ブランド品・骨董品など12ジャンルを高価買取。遺品整理にも対応しております。
            </p>
            <div className="flex gap-3">
              <a
                href="https://lin.ee/OGQq9z6"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackLineClick('footer_social')}
                className="w-9 h-9 flex items-center justify-center rounded-full border border-stone-700 text-stone-400 hover:text-white hover:border-stone-500 transition-colors cursor-pointer"
              >
                <i className="ri-line-line" />
              </a>
              {['ri-instagram-line', 'ri-twitter-x-line', 'ri-facebook-circle-line'].map((icon) => (
                <div
                  key={icon}
                  className="w-9 h-9 flex items-center justify-center rounded-full border border-stone-700 text-stone-400 hover:text-white hover:border-stone-500 transition-colors cursor-pointer"
                >
                  <i className={icon} />
                </div>
              ))}
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-widest mb-5">
              <a href="#service">サービス</a>
            </h4>
            <ul className="space-y-3">
              {[
                { label: '出張買取について', id: 'service' },
                { label: '取扱ジャンル', id: 'genres' },
                { label: '対応地域', id: 'regions' },
                { label: '遺品整理サービス', id: 'service' },
                { label: 'お問い合わせ', id: 'contact' },
              ].map((item) => (
                <li key={item.label}>
                  <button
                    onClick={() => {
                      const el = document.getElementById(item.id);
                      if (el) el.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="text-stone-400 hover:text-amber-400 text-sm transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-white font-semibold text-sm uppercase tracking-widest mb-5">
              <a href="#company">連絡先</a>
            </h4>
            <ul className="space-y-4">
              <li className="flex gap-3">
                <div className="w-5 h-5 flex items-center justify-center text-amber-400 shrink-0 mt-0.5">
                  <i className="ri-map-pin-line" />
                </div>
                <div className="text-stone-400 text-sm leading-relaxed">
                  〒810-0075<br />
                  福岡県福岡市中央区港<br />
                  1-2-18-1712
                </div>
              </li>
              <li className="flex gap-3">
                <div className="w-5 h-5 flex items-center justify-center text-amber-400 shrink-0">
                  <i className="ri-phone-line" />
                </div>
                <a
                  href="tel:0120-676-337"
                  onClick={() => trackPhoneClick('footer_info')}
                  className="text-stone-400 hover:text-white text-sm transition-colors cursor-pointer"
                >
                  0120-676-337
                </a>
              </li>
              <li className="flex gap-3">
                <div className="w-5 h-5 flex items-center justify-center text-amber-400 shrink-0">
                  <i className="ri-mail-line" />
                </div>
                <a
                  href="mailto:info@botan-buy.com"
                  onClick={() => trackEmailClick('footer_info')}
                  className="text-stone-400 hover:text-white text-sm transition-colors cursor-pointer break-all"
                >
                  info@botan-buy.com
                </a>
              </li>
              <li className="flex gap-3">
                <div className="w-5 h-5 flex items-center justify-center shrink-0" style={{ color: '#06C755' }}>
                  <i className="ri-line-line" />
                </div>
                <a
                  href="https://lin.ee/OGQq9z6"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => trackLineClick('footer_info')}
                  className="text-stone-400 hover:text-white text-sm transition-colors cursor-pointer"
                >
                  公式LINE
                </a>
              </li>
              <li className="flex gap-3">
                <div className="w-5 h-5 flex items-center justify-center text-amber-400 shrink-0">
                  <i className="ri-building-2-line" />
                </div>
                <div className="text-stone-400 text-sm">
                  株式会社BotaN<br />
                  <span className="text-stone-500 text-xs">古物商 福岡県公安委員会<br />第901012610013号</span>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-stone-800 py-5 px-6 md:px-12">
        <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-stone-500 text-xs">
            © 2025 天神屋 / 株式会社BotaN All rights reserved.
          </p>
          <button
            onClick={scrollToTop}
            className="flex items-center gap-2 text-stone-500 hover:text-amber-400 text-xs transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-up-line" />
            PAGE TOP
          </button>
        </div>
      </div>
    </footer>
  );
}
